const Row = ({ label, value }) => (
  <div className="flex items-center justify-between py-3  border-b ">
    <span className="text-gray-500">{label}</span>
    <span className="font-medium">{value}</span>
  </div>
);

export default Row;
